// src/pages/Sales/SalesDashboard.jsx
import React from "react";
import { Row, Col, Card, Typography } from "antd";
import {
  PlusCircleOutlined,
  UserOutlined,
  RollbackOutlined,
  RetweetOutlined,
  FileTextOutlined,
  FileSyncOutlined,
  FileSearchOutlined,
  FileProtectOutlined,
  ShoppingCartOutlined,
  UserSwitchOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./salesDashboard.css";
import { accessChecker } from "../lib/functions";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import { useSelector } from "react-redux";

const { Title } = Typography;

const SalesDashboard = () => {
  const navigate = useNavigate();
  const authInfo = useSelector(selectAuthInfo);
  // path: "/purchase?tab=entry",
  let cards = [
    {
      key: "new_sales",
      title: "Sales Entry",
      value: "new_sales",
      icon: <PlusCircleOutlined />,
      path: "/sales?tab=entry",
    },
    {
      key: "customer_entry",
      title: "Customers",
      value: "customer_entry",
      icon: <UserOutlined />,
      path: "/customers?tab=entry",
    },
    {
      key: "customer_group_entry",
      title: "Customers Group Entry",
      value: "customer_entry",
      icon: <UserOutlined />,
      path: "/customers?tab=customers_group",
    },
    {
      key: "sales_return",
      title: "Sales Return",
      value: "sales_return",
      icon: <RollbackOutlined />,
      path: "/sales-returns?tab=entry",
    },
    {
      key: "contract_sales",
      title: "Customers Special Price",
      value: "contract_sales",
      icon: <FileTextOutlined />,
      path: "/customers?tab=customers_special_price",
    },
    {
      key: "sales_voucher",
      title: "Sales Voucher",
      value: "sales_voucher",
      icon: <FileSyncOutlined />,
      path: "/sales?tab=voucher",
    },
    {
      key: "sales_return_voucher",
      title: "Sales Return Voucher",
      value: "sales_return_voucher",
      icon: <FileProtectOutlined />,
      path: "/sales-returns?tab=voucher",
    },
    {
      key: "sales_record",
      title: "Sales Record",
      value: "sales_record",
      icon: <FileSearchOutlined />,
      path: "/sales?tab=record",
    },
    {
      key: "sales_return_record",
      title: "Sales Return Record",
      value: "sales_return_record",
      icon: <FileSearchOutlined />,
      path: "/sales-returns?tab=record",
    },
  ];

  if (
    authInfo?.branch_company_type === "Pharmacy" ||
    authInfo?.subscription === "SuperERP"
  ) {
    cards = cards.filter((c) => c.key !== "new_sales");

    cards.unshift(
      {
        key: "pharma_sales",
        title: "Pharma Sales",
        value: "pharma_sales",
        icon: <SolutionOutlined />,
        path: "/sales?tab=pharma_sales",
      },
      {
        key: "doctor_overview",
        title: "Doctor Overview",
        value: "doctor_overview",
        icon: <SolutionOutlined />,
        path: "/sales/doctor-overview",
      },
      {
        key: "patient_overview",
        title: "Patient Overview",
        value: "patient_overview",
        icon: <UserSwitchOutlined />,
        path: "/sales/patient-overview",
      }
    );
  }

  const filteredMenuData = cards.filter((menuItem) =>
    accessChecker(menuItem.value)
  );

  return (
    <div className="sales-dashboard">
      <Title level={3} className="dashboard-heading">
        Sales
      </Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData
          ?.sort((a, b) => a.title.localeCompare(b.title))
          .map((card, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                hoverable
                className="sales-dashboard-card"
                onClick={() => navigate(card.path)}
              >
                <div className="sales-card-content">
                  <div className="sales-card-icon">{card.icon}</div>
                  <div className="sales-card-title">{card.title}</div>
                </div>
              </Card>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default SalesDashboard;
